import { maritalStatusEnum, sexEnum } from '../enums';
import z from 'zod';

//TOCHECK: what validations should we do for the fields? which can be left empty?
export const updateFormSchema = z.object({
  email: z.string().email({
    message: 'Please enter a valid email address.',
  }),
  firstName: z.string().min(1, {
    message: 'Please enter at least 1 characters for the first name.',
  }),
  lastName: z.string().min(1, {
    message: 'Please enter at least 1 characters for the last name.',
  }),
  sex: sexEnum,
  phoneNumber: z.string().min(10, {
    message: 'Please enter a valid phone number (10 digits).',
  }),
  countryCode: z.number().optional(),

  address: z.string().min(1, {
    message: 'Please enter a valid address',
  }),
  country: z.string().optional(),
  city: z.string(),
  state: z.string(),
  zipCode: z.string(),
  maritalStatus: maritalStatusEnum,
});

export type UpdateFormData = z.infer<typeof updateFormSchema>;
